export default class PlatformType{
    static WP = 'willplatine' as string;
    static AM = 'aunna' as string;
}